import { render } from "./SparklineComponent.vue?vue&type=template&id=8a651c14&scoped=true&ts=true"
import script from "./SparklineComponent.vue?vue&type=script&lang=ts"
export * from "./SparklineComponent.vue?vue&type=script&lang=ts"

import "./SparklineComponent.vue?vue&type=style&index=0&id=8a651c14&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a651c14"]])

export default __exports__